import * as actions from "./actions";
import reducer, * as selectors from "./reducer";

export default { actions, reducer, selectors };